module.exports = __webpack_public_path__ + "static/media/mongo.2bbfb6aa.jpg";